<footer class="app-footer">
  <div class="footer-content">
    <div class="footer-left">
      <div class="footer-brand">
        <mat-icon class="footer-icon">energy_savings_leaf</mat-icon>
        <span class="footer-text">{{ 'footer.brand' | transloco }}</span>
      </div>
      <p class="footer-description">{{ 'footer.tagline' | transloco }}</p>
    </div>

    <div class="footer-right">
      <div class="footer-links">
        <a href="/privacy" class="footer-link">{{ 'footer.privacy' | transloco }}</a>
        <a href="/terms" class="footer-link">{{ 'footer.terms' | transloco }}</a>
        <a href="/contact" class="footer-link">{{ 'footer.contact' | transloco }}</a>
      </div>
      <div class="footer-copyright">
        <p>{{ 'footer.copyright' | transloco: { year: currentYear } }}</p>
      </div>
    </div>
  </div>
</footer>